import type {
  MetricCardDefinition,
  MetricDefinition,
  ResultsTabValue,
} from './results-step.types';

export const RESULTS_TABS: { value: ResultsTabValue; label: string }[] = [
  { value: 'overview', label: 'Overview' },
  { value: 'non-modeled', label: 'Non-modeled aid results' },
  { value: 'admit-adjustments', label: 'Admit adjustments' },
];

export const DEFAULT_RESULTS_TAB: ResultsTabValue = 'overview';

export const OVERVIEW_METRICS: MetricDefinition[] = [
  {
    key: 'enrollment',
    label: 'Enrollment',
    kind: 'count',
    field: 'enrollment',
  },
  {
    key: 'netTuitionRevenue',
    label: 'Net revenue',
    kind: 'currency',
    field: 'netTuitionRevenue',
  },
  {
    key: 'institutionalAid',
    label: 'Institutional aid',
    kind: 'currency',
    field: 'institutionalAid',
    neutralBadge: true,
  },
  {
    key: 'tuitionDiscountRate',
    label: 'Tuition discount',
    kind: 'rate',
    field: 'tuitionDiscountRate',
    invertBadge: true,
  },
  { key: 'yield', label: 'Yield', kind: 'rate', field: 'yieldRate' },
];

export const NET_COMPREHENSIVE_FEE_KEY_PREFIX = 'mv-aid-studio-net-comp-fee';

export const TOTAL_FIRST_YEAR_CARDS: MetricCardDefinition[] = [
  {
    key: 'enrollment',
    label: 'Est. enrollment',
    kind: 'count',
    field: 'enrollment',
    originalTooltip: 'Actual enrollment',
  },
  {
    key: 'netTuitionRevenue',
    label: 'Est. NTR',
    kind: 'currency',
    field: 'netTuitionRevenue',
    originalTooltip: 'Actual NTR',
    netComprehensiveFee: {
      key: 'netComprehensiveFeeRevenue',
      label: 'Net comp. fee revenue',
      kind: 'currency',
      field: 'netComprehensiveFeeRevenue',
      originalTooltip: 'Actual net comp. fee revenue',
    },
  },
  {
    key: 'institutionalAid',
    label: 'Est. Institutional Aid',
    kind: 'currency',
    field: 'institutionalAid',
    originalTooltip: 'Actual institutional aid',
  },
  {
    key: 'tuitionDiscountRate',
    label: 'Est. tuition discount rate',
    kind: 'rate',
    field: 'tuitionDiscountRate',
    originalTooltip: 'Actual tuition discount rate',
    netComprehensiveFee: {
      key: 'comprehensiveFeeDiscountRate',
      label: 'Net comp. fee discount',
      kind: 'rate',
      field: 'comprehensiveFeeDiscountRate',
      originalTooltip: 'Actual net comp. fee discount',
    },
  },
  {
    key: 'yield',
    label: 'Yield',
    kind: 'rate',
    field: 'yieldRate',
    originalTooltip: 'Actual yield',
  },
];

export const COMPARISON_METRICS: MetricDefinition[] = [
  {
    key: 'enrollment',
    label: 'Enrollment',
    kind: 'count',
    field: 'enrollment',
  },
  {
    key: 'netTuitionRevenue',
    label: 'NTR',
    kind: 'currency',
    field: 'netTuitionRevenue',
  },
  {
    key: 'institutionalAid',
    label: 'Inst. Aid',
    kind: 'currency',
    field: 'institutionalAid',
  },
  {
    key: 'tuitionDiscountRate',
    label: 'Tuition Discount',
    kind: 'rate',
    field: 'tuitionDiscountRate',
  },
  { key: 'yield', label: 'Yield', kind: 'rate', field: 'yieldRate' },
];

export const NON_AID_POPULATION_LABEL = 'Non-aid apps';

export const EMPTY_VALUE = '—';
